import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import "../styles/components/footer.scss";
import { useLanguage } from '../contexts/LanguageContext';
import cld from '../config/cloudinaryConfig';
import { AdvancedImage, lazyload } from '@cloudinary/react';
import { format, quality } from '@cloudinary/url-gen/actions/delivery';
import { scale } from '@cloudinary/url-gen/actions/resize';


const Footer = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    const clearHomeScrollTarget = () => {
        if (window.sessionStorage) {
            window.sessionStorage.removeItem('mf-scroll-target');
        }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const handleLogoClick = (event) => {
        if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.altKey ||
            event.ctrlKey ||
            event.shiftKey
        ) {
            return;
        }

        event.preventDefault();
        clearHomeScrollTarget();
        navigate("/");
        scrollToTop();
        window.requestAnimationFrame(scrollToTop);
    };

    const logoUrl = cld.image('logoFooterChatGPT26_oxnohb').delivery(quality('auto')).delivery(format('auto'));
    const metropolisBgUrl = cld.image('metropolisBW_c4lk7v').delivery(quality('auto')).delivery(format('auto')).toURL();
    const facebookIconUrl = cld.image('facebook_bdugv1').delivery(quality('auto')).delivery(format('auto')).toURL();
    const twitterIconUrl = cld.image('twitter_xxgnye').delivery(quality('auto')).delivery(format('auto')).toURL();
    const instagramIconUrl = cld.image('instagram_xsgolf').delivery(quality('auto')).delivery(format('auto')).toURL();
    const linkedinIconUrl = cld.image('linkedin_ry7uii').delivery(quality('auto')).delivery(format('auto')).toURL();
    const youtubeIconUrl = cld.image('youtube_l2gohc').delivery(quality('auto')).delivery(format('auto')).toURL();
    const pinterestIconUrl = cld.image('pinterest_ouhgem').delivery(quality('auto')).delivery(format('auto')).toURL();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 768);
            };

            window.addEventListener('resize', handleResize);
            handleResize(); // Appel initial pour définir l'état

            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);

    return (
        <footer className="footer"
            style={{ paddingTop: "2rem", paddingBottom: "2rem" }}
        >
            <div className="triangle-logo"
                style={{ backgroundColor: "transparent", position: "relative", zIndex: 1 }}
            >
                <div className="triangle-top"></div>
                <div className="text-center logo-container">
                    <Link to="/" onClick={handleLogoClick}>
                        <AdvancedImage
                            cldImg={logoUrl}
                            alt="Movie Frenzy E logo"
                            id="logoFooter"
                            style={{ backgroundColor: "transparent" }}
                            plugins={[lazyload()]}
                        />
                    </Link>
                </div>
            </div>
            <div className="footer-container container-fluid">
                <div className="row linkFormu w-100">
                    <div className="left col-12 col-md-6">
                        <div className="row linkrow">
                            <div className="column col-6 lesLinks">
                                <h2>{t('footer.entreprise')}</h2>
                                <div className="links">
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.conditions')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.politiqueConfidentialite')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.cookies')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.assistance')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.partenaires')}
                                    </button>
                                </div>
                            </div>
                            <div className="column col-6 lesLinks">
                                <h2>{t('footer.accesRapide')}</h2>
                                <div className="links">
                                    {/* <Link to="/filmsPopulaires" className="linkPop">
                                        <button className="footer-link">Films populaires</button>
                                    </Link> */}
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.filmsPopulaires')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.categories')}
                                    </button>
                                    <button
                                        className="footer-link"
                                        onClick={() => navigate("/acteur")}
                                    >
                                        {t('footer.acteurs')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.apropos')}
                                    </button>
                                    <button className="footer-link" onClick={() => { }}>
                                        {t('footer.connexion')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right col-12 col-md-6" style={{ backgroundImage: `url(${metropolisBgUrl})` }}>
                        <div className="newsletter">
                            <h2 className="newsletter-title">
                                {t('footer.inscrisNewsletter')}
                            </h2>
                            <div className="input-container">
                                <input type="text" placeholder={t('footer.emailPlaceholder')}
                                    style={{
                                        transform: isMobile ? 'translateY(50%)' : 'none',
                                    }}
                                />
                                <button
                                    className="submit-button"
                                    style={{
                                        marginTop: isMobile ? '1.5rem' : '0',
                                        transform: isMobile ? 'translateY(15px)' : 'none',
                                    }}
                                >
                                    {t('footer.envoyer')}
                                </button>
                            </div>
                        </div>
                        <div
                            className="social-icons row g-1 flex-nowrap justify-content-center mx-0"
                            style={{
                                transform: isMobile ? 'scale(0.8)' : 'none',
                                transformOrigin: 'center center',
                                marginTop: '2rem',
                                position: 'relative',
                                zIndex: 2,
                                gap: isMobile ? '0.5rem' : '1rem',
                                paddingLeft: isMobile ? '1.75rem' : '0',
                            }}
                        >
                            <div className="col-auto">
                                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                                    <img src={facebookIconUrl} alt="Facebook" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                            <div className="col-auto">
                                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                                    <img src={twitterIconUrl} alt="Twitter" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                            <div className="col-auto">
                                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                    <img src={instagramIconUrl} alt="Instagram" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                            <div className="col-auto">
                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                                    <img src={linkedinIconUrl} alt="LinkedIn" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                            <div className="col-auto">
                                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
                                    <img src={youtubeIconUrl} alt="YouTube" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                            <div className="col-auto">
                                <a href="https://www.pinterest.com" target="_blank" rel="noopener noreferrer">
                                    <img src={pinterestIconUrl} alt="Pinterest" className="networkIcon" loading="lazy" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyR row">
                    <div className="col-12">
                        {t('footer.copyright')}<span>&nbsp;©</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
